(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CONTACT"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-contact-form-wrap]').forEach(function (wrap) {
      if (wrap.dataset.delivery !== 'mailto') return;


      var recipient = (wrap.dataset.recipient || '').trim();
      var form = wrap.querySelector('form');
      if (!form || !recipient) return;


      form.addEventListener('submit', function (e) {
        e.preventDefault();


        var nameEl = form.querySelector('#ContactForm-name');
        var emailEl = form.querySelector('#ContactForm-email');
        var phoneEl = form.querySelector('#ContactForm-phone');
        var bodyEl = form.querySelector('#ContactForm-body');


        var name = nameEl ? nameEl.value.trim() : '';
        var fromEmail = emailEl ? emailEl.value.trim() : '';
        var phone = phoneEl ? phoneEl.value.trim() : '';
        var message = bodyEl ? bodyEl.value.trim() : '';


        var subject = 'New message from ' + (name || fromEmail || 'website contact form');
        var bodyLines = [];
        if (name) bodyLines.push('Name: ' + name);
        if (fromEmail) bodyLines.push('Email: ' + fromEmail);
        if (phone) bodyLines.push('Phone: ' + phone);
        bodyLines.push('');
        bodyLines.push(message);


        var mailto = 'mailto:' + encodeURIComponent(recipient)
          + '?subject=' + encodeURIComponent(subject)
          + '&body=' + encodeURIComponent(bodyLines.join('\n'));


        window.location.href = mailto;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('[data-faq-list]').forEach(function (list) {

      if (list.dataset.faqInit) {
        return;
      }

      list.dataset.faqInit = 'true';


      /* =====================================
         SETTINGS
         ===================================== */

      var singleOpen =
        list.getAttribute('data-single-open') === 'true';

      var items =
        list.querySelectorAll('[data-faq-item]');


      /* =====================================
         FAQ ITEMS
         ===================================== */

      items.forEach(function (item) {

        var trigger =
          item.querySelector('[data-faq-trigger]');

        if (!trigger) {
          return;
        }


        trigger.addEventListener('click', function () {

          var willOpen =
            item.getAttribute('data-open') !== 'true';


          /* ===================================
             CLOSE OTHER ITEMS
             =================================== */

          if (singleOpen && willOpen) {

            items.forEach(function (other) {

              if (other !== item) {

                other.setAttribute(
                  'data-open',
                  'false'
                );

                var otherTrigger =
                  other.querySelector(
                    '[data-faq-trigger]'
                  );

                if (otherTrigger) {

                  otherTrigger.setAttribute(
                    'aria-expanded',
                    'false'
                  );

                }

              }

            });

          }


          /* ===================================
             TOGGLE CURRENT ITEM
             =================================== */

          item.setAttribute(
            'data-open',
            willOpen ? 'true' : 'false'
          );

          trigger.setAttribute(
            'aria-expanded',
            willOpen ? 'true' : 'false'
          );

        });

      });

    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('[id^="Slideshow-"]').forEach(function (container) {

    if (container.dataset.slideshowInit) {
      return;
    }

    container.dataset.slideshowInit = 'true';

    var slides = container.querySelectorAll('.simple-slide');
    var dots = container.querySelectorAll('.simple-slider-dot');

    var prevButton = container.querySelector('.simple-slider-prev');
    var nextButton = container.querySelector('.simple-slider-next');

    if (slides.length <= 1) {
      return;
    }

    var index = 0;

    var autoplaySpeed = parseInt(
      container.dataset.speed || '3000',
      10
    );

    var autoplayTimer;


    /* =========================================
       SHOW SLIDE
       ========================================= */

    function showSlide(newIndex) {

      if (newIndex < 0) {
        newIndex = slides.length - 1;
      }

      if (newIndex >= slides.length) {
        newIndex = 0;
      }

      slides[index].classList.remove('is-active');

      if (dots[index]) {
        dots[index].classList.remove('is-active');
        dots[index].setAttribute('aria-selected', 'false');
      }

      index = newIndex;

      slides[index].classList.add('is-active');

      if (dots[index]) {
        dots[index].classList.add('is-active');
        dots[index].setAttribute('aria-selected', 'true');
      }

    }


    /* =========================================
       NEXT SLIDE
       ========================================= */

    function nextSlide() {
      showSlide(index + 1);
    }


    /* =========================================
       PREVIOUS SLIDE
       ========================================= */

    function previousSlide() {
      showSlide(index - 1);
    }


    /* =========================================
       AUTOPLAY
       ========================================= */

    function startAutoplay() {

      clearInterval(autoplayTimer);

      autoplayTimer = setInterval(function () {
        nextSlide();
      }, autoplaySpeed);

    }


    function stopAutoplay() {

      clearInterval(autoplayTimer);

    }


    /* =========================================
       NEXT BUTTON
       ========================================= */

    if (nextButton) {

      nextButton.addEventListener('click', function () {

        nextSlide();
        startAutoplay();

      });

    }


    /* =========================================
       PREVIOUS BUTTON
       ========================================= */

    if (prevButton) {

      prevButton.addEventListener('click', function () {

        previousSlide();
        startAutoplay();

      });

    }


    /* =========================================
       DOT NAVIGATION
       ========================================= */

    dots.forEach(function (dot) {

      dot.addEventListener('click', function () {

        var target = parseInt(
          dot.dataset.slide,
          10
        );

        showSlide(target);
        startAutoplay();

      });

    });


    /* =========================================
       PAUSE ON HOVER
       ========================================= */

    container.addEventListener('mouseenter', function () {

      stopAutoplay();

    });


    container.addEventListener('mouseleave', function () {

      startAutoplay();

    });


    /* =========================================
       START AUTOPLAY
       ========================================= */

    startAutoplay();

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
